import e from "../../utils/classNames.js";
import t from "../tooltip/SimpleTooltip.js";
import n from "../button/Button.js";
import { noop as r } from "es-toolkit/function";
import { jsx as i } from "react/jsx-runtime";
//#region src/components/sidebars/SidebarFullscreenToggle.tsx
var a = ({ isFullscreen: a, tooltip: o, onClick: s = r }) => {
	let c = e("uikit-icon", a ? "icon-resize-small" : "icon-resize-full"), l = /* @__PURE__ */ i(n, {
		bsStyle: n.MUTED,
		iconOnly: !0,
		onClick: s,
		"data-testid": "sidebarFullscreenToggle",
		children: /* @__PURE__ */ i("span", { className: c })
	});
	return o ? /* @__PURE__ */ i(t, {
		content: o,
		placement: "bottom",
		children: l
	}) : l;
};
//#endregion
export { a as default };

//# sourceMappingURL=SidebarFullscreenToggle.js.map